import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Box,
  Typography,
} from "@mui/material";
import { Logout } from "@mui/icons-material";
import useCookie from "../hooks/useCookie";
import { useINavigation } from "../hooks/useINavigation";
import { useLogout } from "../hooks/useLogout";
import { useAppState } from "../store/contextProvider";
import { getProfileMenuOptions } from "../../config/ProfileMenuOptions";

const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { getToken } = useCookie();
  const { navigateTo } = useINavigation();
  const { logout } = useLogout();
  const { session } = useAppState();
  const open = Boolean(anchorEl);
  const menuOptions = getProfileMenuOptions();

  const handleClose = () => setAnchorEl(null);

  const handleMenuAction = (option) => {
    if (option.page) navigateTo(option.page);
    handleClose();
  };

  const handleLogout = () => {
    handleClose();
    logout(); // API logout (session, cookie, trend cache) + socket, cookies, configs -> login
  };

  const token = getToken();
  const ud = session?.userDetails;
  const displayName = ud?.firstName || token?.userName || "User";
  const initials = (displayName || "U").charAt(0).toUpperCase();

  return (
    <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
      <IconButton
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
        aria-controls={open ? "profile-menu" : undefined}
        aria-haspopup="true"
        sx={{ color: "inherit" }}
      >
        <Avatar sx={{ width: 32, height: 32, bgcolor: "rgba(255,255,255,0.2)", fontSize: "0.875rem" }}>
          {initials}
        </Avatar>
      </IconButton>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        PaperProps={{ sx: { minWidth: 200, mt: 1.5 } }}
      >
        <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid #e0e0e0" }}>
          <Typography variant="subtitle2" fontWeight={600}>
            {displayName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {ud?.email || token?.email || ""}
          </Typography>
        </Box>
        {menuOptions.map((option) => (
          <MenuItem key={option.id} onClick={() => handleMenuAction(option)}>
            <ListItemIcon>
              <option.icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
        <MenuItem onClick={handleLogout} sx={{ borderTop: "1px solid #e0e0e0", mt: 1 }}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileMenu;
